/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sign_UpInputs */

const en_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Account`)
};

const es_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear cuenta`)
};

const fr_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un compte`)
};

const de_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto erstellen`)
};

const ja_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウント作成`)
};

const zh_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建账号`)
};

const ar_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء حساب`)
};

const id_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat Akun`)
};

const it_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea Account`)
};

const ru_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать аккаунт`)
};

const pt_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar Conta`)
};

const ko_auth_sign_up = /** @type {(inputs: Auth_Sign_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정 만들기`)
};

/**
* | output |
* | --- |
* | "Create Account" |
*
* @param {Auth_Sign_UpInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const auth_sign_up = /** @type {((inputs?: Auth_Sign_UpInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sign_UpInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_sign_up(inputs)
	if (locale === "es") return es_auth_sign_up(inputs)
	if (locale === "fr") return fr_auth_sign_up(inputs)
	if (locale === "de") return de_auth_sign_up(inputs)
	if (locale === "ja") return ja_auth_sign_up(inputs)
	if (locale === "zh") return zh_auth_sign_up(inputs)
	if (locale === "ar") return ar_auth_sign_up(inputs)
	if (locale === "id") return id_auth_sign_up(inputs)
	if (locale === "it") return it_auth_sign_up(inputs)
	if (locale === "ru") return ru_auth_sign_up(inputs)
	if (locale === "pt") return pt_auth_sign_up(inputs)
	return ko_auth_sign_up(inputs)
});